import apis from '.';

export const genPaymentUrl = async (bankCode = "", currCode = "VND", billingAddress = "test", orderProduct = [
    {
        "productCode": "RO86947C",
        "quantity": 2
    },
    {
        "productCode": "RO86947C",
        "quantity": 3
    }
], promotionCode, token) => {
    try {
        const response = await apis.post(
            "/payment/gen-payment-url",
            {
                bankCode: bankCode,
                currCode: currCode,
                billingAddress: billingAddress,
                orderProduct: orderProduct,
                promotionCode: promotionCode
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}

export async function updateOrderPayment(query, token) {
    try {
        const result = await apis.post('/payment/update' + query, null,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )

        return result
    } catch (error) {
        throw error.response ? error.response.data : error;
    }
}